var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "main_logo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 806.4 54.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.3,45.91c2.55,0,4.63-.28,6.22-.84,3.02-1.08,4.54-3.08,4.54-6.01,0-1.71-.75-3.04-2.25-3.97-1.5-.91-3.86-1.72-7.07-2.43l-5.48-1.23c-5.39-1.22-9.12-2.54-11.18-3.97-3.49-2.39-5.24-6.13-5.24-11.21,0-4.64,1.69-8.5,5.06-11.57C9.28,1.61,14.24.07,20.78.07c5.46,0,10.12,1.45,13.97,4.34,3.85,2.9,5.88,7.1,6.06,12.6h-10.41c-.19-3.12-1.55-5.33-4.08-6.64-1.69-.87-3.79-1.3-6.29-1.3-2.79,0-5.02.56-6.68,1.69-1.66,1.12-2.5,2.7-2.5,4.71,0,1.85.82,3.23,2.46,4.15,1.05.61,3.3,1.32,6.75,2.14l8.93,2.14c3.91.94,6.87,2.19,8.86,3.76,3.09,2.44,4.64,5.96,4.64,10.58s-1.81,8.67-5.43,11.79-8.74,4.69-15.35,4.69-12.06-1.54-15.93-4.62c-3.87-3.08-5.8-7.32-5.8-12.71h10.34c.33,2.37.97,4.14,1.93,5.31,1.76,2.13,4.77,3.2,9.04,3.2Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.99,53.4h-13.92l-16-22.64-5.17,5.31v17.33h-10.65V1.58h10.65v21.34L79.91,1.58h13.99l-21.23,21.34,22.32,30.48Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.79,1.58h10.76v51.82h-10.76V1.58Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.2,1.58h10.83v42.5h25.66v9.32h-36.49V1.58Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.74,1.58h10.83v42.5h25.66v9.32h-36.49V1.58Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.65,45.91c2.55,0,4.63-.28,6.22-.84,3.02-1.08,4.54-3.08,4.54-6.01,0-1.71-.75-3.04-2.25-3.97-1.5-.91-3.86-1.72-7.07-2.43l-5.48-1.23c-5.39-1.22-9.12-2.54-11.18-3.97-3.49-2.39-5.24-6.13-5.24-11.21,0-4.64,1.69-8.5,5.06-11.57,3.38-3.07,8.33-4.61,14.87-4.61,5.46,0,10.12,1.45,13.97,4.34,3.86,2.9,5.88,7.1,6.06,12.6h-10.41c-.19-3.12-1.55-5.33-4.08-6.64-1.69-.87-3.79-1.3-6.29-1.3-2.79,0-5.02.56-6.68,1.69s-2.5,2.7-2.5,4.71c0,1.85.82,3.23,2.46,4.15,1.05.61,3.3,1.32,6.75,2.14l8.93,2.14c3.91.94,6.87,2.19,8.86,3.76,3.09,2.44,4.64,5.96,4.64,10.58s-1.81,8.67-5.43,11.79-8.74,4.69-15.35,4.69-12.06-1.54-15.93-4.62c-3.87-3.08-5.8-7.32-5.8-12.71h10.34c.33,2.37.97,4.14,1.93,5.31,1.76,2.13,4.77,3.2,9.04,3.2Z",
    style: {
      fill: "#d4145a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.33,53.4v-23.13h-20.25v23.13h-10.72V1.58h10.72v19.76h20.25V1.58h10.76v51.82h-10.76Z",
    style: {
      fill: "#d4145a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m355.05,30.76h-25.17v13.32h28.69v9.32h-39.27V1.58h38v9.18h-27.42v11h25.17v9Z",
    style: {
      fill: "#d4145a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.64,30.76h-25.17v13.32h28.69v9.32h-39.27V1.58h38v9.18h-27.42v11h25.17v9Z",
    style: {
      fill: "#d4145a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.8,1.58v9.18h-15.5v42.64h-10.9V10.76h-15.57V1.58h41.98Z",
    style: {
      fill: "#d4145a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m509.99,10.76h-25.98v11.92h22.75v9h-22.75v21.73h-10.76V1.65h36.74v9.11Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m546.14,42.75h-19.09l-3.59,10.65h-11.32l18.49-51.82h12.23l18.35,51.82h-11.74l-3.34-10.65Zm-3.02-8.93l-6.47-20.39-6.68,20.39h13.15Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602.91,49.53c-3.87,3.54-8.81,5.31-14.84,5.31-7.45,0-13.31-2.39-17.58-7.17-4.27-4.8-6.4-11.39-6.4-19.76,0-9.05,2.43-16.02,7.28-20.92,4.22-4.27,9.59-6.4,16.1-6.4,8.72,0,15.09,2.86,19.12,8.58,2.23,3.21,3.42,6.43,3.59,9.67h-10.83c-.7-2.48-1.61-4.36-2.71-5.62-1.97-2.25-4.89-3.38-8.75-3.38s-7.04,1.59-9.32,4.76c-2.27,3.18-3.41,7.67-3.41,13.48s1.2,10.17,3.6,13.06c2.4,2.9,5.46,4.34,9.16,4.34s6.69-1.24,8.68-3.73c1.1-1.34,2.02-3.34,2.74-6.01h10.72c-.94,5.65-3.33,10.24-7.17,13.78Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m654.56,1.58v9.18h-15.5v42.64h-10.9V10.76h-15.57V1.58h41.98Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m682.37,54.84c-7.41,0-13.07-2.02-16.98-6.05-5.25-4.94-7.88-12.07-7.88-21.37s2.62-16.62,7.88-21.38c3.91-4.03,9.57-6.05,16.98-6.05s13.07,2.02,16.98,6.05c5.23,4.76,7.84,11.88,7.84,21.38s-2.61,16.43-7.84,21.37c-3.91,4.03-9.57,6.05-16.98,6.05Zm10.23-13.92c2.51-3.16,3.76-7.66,3.76-13.5s-1.26-10.31-3.78-13.48c-2.52-3.18-5.92-4.76-10.21-4.76s-7.71,1.58-10.27,4.75-3.83,7.66-3.83,13.5,1.28,10.34,3.83,13.5c2.55,3.16,5.98,4.75,10.27,4.75s7.7-1.58,10.23-4.75Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m736.02,33.08h-11.18v20.32h-10.58V1.58h25.42c3.63.07,6.43.52,8.38,1.34,1.96.82,3.62,2.03,4.97,3.62,1.12,1.31,2.02,2.77,2.67,4.36.66,1.59.98,3.41.98,5.45,0,2.46-.62,4.88-1.86,7.26-1.24,2.38-3.29,4.06-6.15,5.04,2.39.96,4.08,2.33,5.08,4.1,1,1.77,1.49,4.47,1.49,8.1v3.48c0,2.37.09,3.97.28,4.82.28,1.34.94,2.32,1.97,2.95v1.3h-11.92c-.33-1.15-.56-2.07-.7-2.78-.28-1.45-.43-2.94-.46-4.46l-.07-4.82c-.05-3.3-.65-5.51-1.81-6.61-1.16-1.1-3.33-1.65-6.52-1.65Zm6.57-9.42c2.16-.98,3.23-2.93,3.23-5.84,0-3.14-1.04-5.25-3.13-6.33-1.17-.61-2.93-.91-5.27-.91h-12.59v13.92h12.27c2.44,0,4.27-.28,5.48-.84Z",
    style: {
      fill: "#4d4d4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m806.4,1.58l-17.33,32.34v19.48h-10.83v-19.48l-17.93-32.34h12.76l10.76,22.57,10.3-22.57h12.27Z",
    style: {
      fill: "#4d4d4d"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f3daa3970e69c5f300804ecff23f013e.svg";
export { ForwardRef as ReactComponent };